import { Link } from "react-router-dom";

export function Logo({ variant = "light", className = "", showWordmark = true, to = "/" }) {
  const textColor = variant === "dark" ? "#FFFFFF" : "#1E2A35";
  const mark = (
    <svg width="36" height="36" viewBox="0 0 46 46" fill="none" aria-hidden="true" className="shrink-0">
      <rect x="2" y="2" width="42" height="42" rx="10" fill="#E07B2A" />
      <polygon points="23,12 35,23 11,23" fill="#1E2A35" />
      <rect x="15" y="23" width="16" height="12" fill="#1E2A35" />
      <rect x="20" y="27" width="6" height="8" fill="#E07B2A" />
    </svg>
  );
  const content = (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      {mark}
      {showWordmark && (
        <span className="font-body font-extrabold text-[20px] tracking-[-0.02em] leading-none" style={{ color: textColor }}>
          Measure<span style={{ color: "#E07B2A" }}>The</span>Roof
        </span>
      )}
    </span>
  );
  if (to) return <Link to={to} aria-label="MeasureTheRoof home" data-testid="logo-link">{content}</Link>;
  return content;
}

export default Logo;
